"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnerType = exports.OffsetPlanType = exports.AdjustCoverageActions = exports.ErrorCode = exports.BenefitTypes = exports.LifeSegmentType = exports.ThirdPartyPaymentStatus = exports.PartyType = exports.CirPoolOption = exports.RefundAction = exports.RefundType = exports.DividendOptionNames = exports.PartialWithdrawalDisbursementType = exports.IssueLoanDisbursementType = exports.DisbursementType = exports.WithdrawalType = exports.WithdrawalPayType = exports.AllowedBeneUpdateType = exports.BeneType = exports.ElasticSearchRequestObjectTrustOrEntity = exports.ElasticSearchRequestObjectOwnerClassification = exports.ContingentOwnerTypes = exports.BeneficiaryClassification = exports.SegmentKind = exports.BreakdownType = exports.PUAOptionTypes = exports.QuotePayloadDescription = exports.RefundBreakdownPayloadDescription = exports.RefundBreakdownDescription = exports.SegmentInfo = exports.NonForfeitureOptions = exports.WorkflowRefType = exports.GovtIdType = exports.ContOwnerKind = exports.PolicyKind = exports.OwnerRole = exports.ClaimType = exports.Title = exports.Gender = exports.AddressTypeCode = exports.PhoneType = exports.Country = exports.BillingOptionTitles = exports.PartyPresenceType = exports.PaymentMethodType = exports.PartyAttributeKey = exports.PolicyAttributeKey = exports.AllowedTransactionStates = exports.InvoicePaymentStatus = exports.RateClassMapping = void 0;
exports.PolicyDocTypeEnum = exports.beneficiaryPerStirpes = exports.TrustType = exports.UpdateBeneAction = exports.EntityType = exports.TrusteeType = exports.PhoneTypeDescription = void 0;
var RateClassMapping_1 = require("./RateClassMapping");
Object.defineProperty(exports, "RateClassMapping", { enumerable: true, get: function () { return RateClassMapping_1.RateClassMapping; } });
var InvoicePaymentStatus;
(function (InvoicePaymentStatus) {
    InvoicePaymentStatus[InvoicePaymentStatus["Success"] = 0] = "Success";
    InvoicePaymentStatus[InvoicePaymentStatus["Failure"] = 1] = "Failure";
})(InvoicePaymentStatus = exports.InvoicePaymentStatus || (exports.InvoicePaymentStatus = {}));
var AllowedTransactionStates;
(function (AllowedTransactionStates) {
    AllowedTransactionStates["True"] = "True";
    AllowedTransactionStates["False"] = "False";
    AllowedTransactionStates["NotSupported"] = "NotSupported";
})(AllowedTransactionStates = exports.AllowedTransactionStates || (exports.AllowedTransactionStates = {}));
var PolicyAttributeKey;
(function (PolicyAttributeKey) {
    PolicyAttributeKey["AccountNumber"] = "AccountNumber";
    PolicyAttributeKey["BankPolicyNumber"] = "BankPolicyNumber";
    PolicyAttributeKey["BankBranchId"] = "BankBranchId";
    PolicyAttributeKey["BankTransitNumber"] = "BankTransitNumber";
    PolicyAttributeKey["BegOfYearContractValue"] = "BegOfYearContractValue";
    PolicyAttributeKey["CostBasisIn"] = "CostBasisIn";
    PolicyAttributeKey["CostBasisOut"] = "CostBasisOut";
    PolicyAttributeKey["CurrentPostTax"] = "CurrentPostTax";
    PolicyAttributeKey["GroupPolicyDescription"] = "GroupPolicyDescription";
    PolicyAttributeKey["GroupPolicyNumber"] = "GroupPolicyNumber";
    PolicyAttributeKey["IsMigrated"] = "IsMigrated";
    PolicyAttributeKey["LoanAmount"] = "LoanAmount";
    PolicyAttributeKey["LoanEffectiveDate"] = "LoanEffectiveDate";
    PolicyAttributeKey["LoanEndDate"] = "LoanEndDate";
    PolicyAttributeKey["InvoiceCountAtMigration"] = "InvoiceCountAtMigration";
    PolicyAttributeKey["TotalPremiumsPaidAtMigration"] = "TotalPremiumsPaidAtMigration";
    PolicyAttributeKey["PayByCheckAutoPay"] = "PayByCheckAutoPay";
    PolicyAttributeKey["Currency"] = "Currency";
})(PolicyAttributeKey = exports.PolicyAttributeKey || (exports.PolicyAttributeKey = {}));
var PartyAttributeKey;
(function (PartyAttributeKey) {
    PartyAttributeKey["BankCIFKey"] = "BankCIFKey";
    PartyAttributeKey["CashIntensiveBusiness"] = "CashIntensiveBusiness";
    PartyAttributeKey["CountryOfNationality"] = "CountryOfNationality";
    PartyAttributeKey["CountryOfResidence"] = "CountryOfResidence";
    PartyAttributeKey["DomesticPEP"] = "DomesticPEP";
    PartyAttributeKey["GovernmentWatchlist"] = "GovernmentWatchlist";
    PartyAttributeKey["InternationalPEP"] = "InternationalPEP";
    PartyAttributeKey["OtherRiskFactors"] = "OtherRiskFactors";
    PartyAttributeKey["PartyComment"] = "PartyComment";
    PartyAttributeKey["PEPAssociation"] = "PEPAssociation";
    PartyAttributeKey["RiskLevel"] = "RiskLevel";
    PartyAttributeKey["PEPLastReviewDate"] = "PEPLastReviewDate";
})(PartyAttributeKey = exports.PartyAttributeKey || (exports.PartyAttributeKey = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["BankAccount"] = "Bank Account";
    PaymentMethodType["CreditCard"] = "Credit Card";
    PaymentMethodType["Check"] = "Pay By Check";
    PaymentMethodType["NoPaymentInfo"] = "No Payment Info";
    PaymentMethodType["ThirdPartyPaymentMethod"] = "Third Party Payment Method";
    PaymentMethodType["ExternalBankPaymentMethod"] = "External Bank Payment";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PartyPresenceType;
(function (PartyPresenceType) {
    PartyPresenceType["NoActivePayer"] = "NoActivePayer";
})(PartyPresenceType = exports.PartyPresenceType || (exports.PartyPresenceType = {}));
var BillingOptionTitles;
(function (BillingOptionTitles) {
    BillingOptionTitles["RegularBilling"] = "RegularBilling";
    BillingOptionTitles["DigitalDirectBillNoAuth"] = "DigitalDirectBillNoAuth";
    BillingOptionTitles["DigitalDirectBillWithAuth"] = "DigitalDirectBillWithAuth";
    BillingOptionTitles["PauseBilling"] = "PauseBilling";
})(BillingOptionTitles = exports.BillingOptionTitles || (exports.BillingOptionTitles = {}));
var Country;
(function (Country) {
    Country["Afghanistan"] = "AF";
    Country["AlandIslands"] = "AX";
    Country["Albania"] = "AL";
    Country["Algeria"] = "DZ";
    Country["AmericanSamoa"] = "AS";
    Country["Andorra"] = "AD";
    Country["Angola"] = "AO";
    Country["Anguilla"] = "AI";
    Country["Antarctica"] = "AQ";
    Country["AntiguaAndBarbuda"] = "AG";
    Country["Argentina"] = "AR";
    Country["Armenia"] = "AM";
    Country["Aruba"] = "AW";
    Country["Australia"] = "AU";
    Country["Austria"] = "AT";
    Country["Azerbaijan"] = "AZ";
    Country["Bahamas"] = "BS";
    Country["Bahrain"] = "BH";
    Country["Bangladesh"] = "BD";
    Country["Barbados"] = "BB";
    Country["Belarus"] = "BY";
    Country["Belgium"] = "BE";
    Country["Belize"] = "BZ";
    Country["Benin"] = "BJ";
    Country["Bermuda"] = "BM";
    Country["Bhutan"] = "BT";
    Country["Bolivia"] = "BO";
    Country["BonaireSintEustatiusSaba"] = "BQ";
    Country["BosniaAndHerzegovina"] = "BA";
    Country["Botswana"] = "BW";
    Country["BouvetIsland"] = "BV";
    Country["Brazil"] = "BR";
    Country["BritishIndianOceanTerritory"] = "IO";
    Country["BruneiDarussalam"] = "BN";
    Country["Bulgaria"] = "BG";
    Country["BurkinaFaso"] = "BF";
    Country["Burundi"] = "BI";
    Country["Cambodia"] = "KH";
    Country["Cameroon"] = "CM";
    Country["Canada"] = "CA";
    Country["CapeVerde"] = "CV";
    Country["CaymanIslands"] = "KY";
    Country["CentralAfricanRepublic"] = "CF";
    Country["Chad"] = "TD";
    Country["Chile"] = "CL";
    Country["China"] = "CN";
    Country["ChristmasIsland"] = "CX";
    Country["CocosKeelingIslands"] = "CC";
    Country["Colombia"] = "CO";
    Country["Comoros"] = "KM";
    Country["Congo"] = "CG";
    Country["CongoDemocraticRepublic"] = "CD";
    Country["CookIslands"] = "CK";
    Country["CostaRica"] = "CR";
    Country["CoteDIvoire"] = "CI";
    Country["Croatia"] = "HR";
    Country["Cuba"] = "CU";
    Country["Curacao"] = "CW";
    Country["Cyprus"] = "CY";
    Country["CzechRepublic"] = "CZ";
    Country["Denmark"] = "DK";
    Country["DiegoGarcia"] = "DG";
    Country["Djibouti"] = "DJ";
    Country["Dominica"] = "DM";
    Country["DominicanRepublic"] = "DO";
    Country["Ecuador"] = "EC";
    Country["Egypt"] = "EG";
    Country["ElSalvador"] = "SV";
    Country["EquatorialGuinea"] = "GQ";
    Country["Eritrea"] = "ER";
    Country["Estonia"] = "EE";
    Country["Ethiopia"] = "ET";
    Country["FalklandIslands"] = "FK";
    Country["FaroeIslands"] = "FO";
    Country["Fiji"] = "FJ";
    Country["Finland"] = "FI";
    Country["France"] = "FR";
    Country["FrenchGuiana"] = "GF";
    Country["FrenchPolynesia"] = "PF";
    Country["FrenchSouthernTerritories"] = "TF";
    Country["Gabon"] = "GA";
    Country["Gambia"] = "GM";
    Country["Georgia"] = "GE";
    Country["Germany"] = "DE";
    Country["Ghana"] = "GH";
    Country["Gibraltar"] = "GI";
    Country["Greece"] = "GR";
    Country["Greenland"] = "GL";
    Country["Grenada"] = "GD";
    Country["Guadeloupe"] = "GP";
    Country["Guam"] = "GU";
    Country["Guatemala"] = "GT";
    Country["Guernsey"] = "GG";
    Country["Guinea"] = "GN";
    Country["GuineaBissau"] = "GW";
    Country["Guyana"] = "GY";
    Country["Haiti"] = "HT";
    Country["HeardIslandMcdonaldIslands"] = "HM";
    Country["HolySeeVaticanCityState"] = "VA";
    Country["Honduras"] = "HN";
    Country["HongKong"] = "HK";
    Country["Hungary"] = "HU";
    Country["Iceland"] = "IS";
    Country["India"] = "IN";
    Country["Indonesia"] = "ID";
    Country["Iran"] = "IR";
    Country["Iraq"] = "IQ";
    Country["Ireland"] = "IE";
    Country["IsleOfMan"] = "IM";
    Country["Israel"] = "IL";
    Country["Italy"] = "IT";
    Country["Jamaica"] = "JM";
    Country["Japan"] = "JP";
    Country["Jersey"] = "JE";
    Country["Jordan"] = "JO";
    Country["Kazakhstan"] = "KZ";
    Country["Kenya"] = "KE";
    Country["Kiribati"] = "KI";
    Country["Korea"] = "KR";
    Country["KoreaDemocraticPeoplesRepublic"] = "KP";
    Country["Kosovo"] = "XK";
    Country["Kuwait"] = "KW";
    Country["Kyrgyzstan"] = "KG";
    Country["LaoPeoplesDemocraticRepublic"] = "LA";
    Country["Latvia"] = "LV";
    Country["Lebanon"] = "LB";
    Country["Lesotho"] = "LS";
    Country["Liberia"] = "LR";
    Country["Libya"] = "LY";
    Country["Liechtenstein"] = "LI";
    Country["Lithuania"] = "LT";
    Country["Luxembourg"] = "LU";
    Country["Macao"] = "MO";
    Country["Macedonia"] = "MK";
    Country["Madagascar"] = "MG";
    Country["Malawi"] = "MW";
    Country["Malaysia"] = "MY";
    Country["Maldives"] = "MV";
    Country["Mali"] = "ML";
    Country["Malta"] = "MT";
    Country["MarshallIslands"] = "MH";
    Country["Martinique"] = "MQ";
    Country["Mauritania"] = "MR";
    Country["Mauritius"] = "MU";
    Country["Mayotte"] = "YT";
    Country["Mexico"] = "MX";
    Country["Micronesia"] = "FM";
    Country["Moldova"] = "MD";
    Country["Monaco"] = "MC";
    Country["Mongolia"] = "MN";
    Country["Montenegro"] = "ME";
    Country["Montserrat"] = "MS";
    Country["Morocco"] = "MA";
    Country["Mozambique"] = "MZ";
    Country["Myanmar"] = "MM";
    Country["Namibia"] = "NA";
    Country["Nauru"] = "NR";
    Country["Nepal"] = "NP";
    Country["Netherlands"] = "NL";
    Country["NetherlandsAntilles"] = "AN";
    Country["NewCaledonia"] = "NC";
    Country["NewZealand"] = "NZ";
    Country["Nicaragua"] = "NI";
    Country["Niger"] = "NE";
    Country["Nigeria"] = "NG";
    Country["Niue"] = "NU";
    Country["NorfolkIsland"] = "NF";
    Country["NorthernMarianaIslands"] = "MP";
    Country["Norway"] = "NO";
    Country["Oman"] = "OM";
    Country["Pakistan"] = "PK";
    Country["Palau"] = "PW";
    Country["Palestine"] = "PS";
    Country["Panama"] = "PA";
    Country["PapuaNewGuinea"] = "PG";
    Country["Paraguay"] = "PY";
    Country["Peru"] = "PE";
    Country["Philippines"] = "PH";
    Country["Pitcairn"] = "PN";
    Country["Poland"] = "PL";
    Country["Portugal"] = "PT";
    Country["PuertoRico"] = "PR";
    Country["Qatar"] = "QA";
    Country["Reunion"] = "RE";
    Country["Romania"] = "RO";
    Country["RussianFederation"] = "RU";
    Country["Rwanda"] = "RW";
    Country["SaintBarthelemy"] = "BL";
    Country["SaintHelena"] = "SH";
    Country["SaintKittsAndNevis"] = "KN";
    Country["SaintLucia"] = "LC";
    Country["SaintMartin"] = "MF";
    Country["SaintPierreAndMiquelon"] = "PM";
    Country["SaintVincentAndGrenadines"] = "VC";
    Country["Samoa"] = "WS";
    Country["SanMarino"] = "SM";
    Country["SaoTomeAndPrincipe"] = "ST";
    Country["SaudiArabia"] = "SA";
    Country["Senegal"] = "SN";
    Country["Serbia"] = "RS";
    Country["Seychelles"] = "SC";
    Country["SierraLeone"] = "SL";
    Country["Singapore"] = "SG";
    Country["SintMaarten"] = "SX";
    Country["Slovakia"] = "SK";
    Country["Slovenia"] = "SI";
    Country["SolomonIslands"] = "SB";
    Country["Somalia"] = "SO";
    Country["SouthAfrica"] = "ZA";
    Country["SouthGeorgiaAndSandwichIsl"] = "GS";
    Country["SouthSudan"] = "SS";
    Country["Spain"] = "ES";
    Country["SriLanka"] = "LK";
    Country["Sudan"] = "SD";
    Country["Suriname"] = "SR";
    Country["SvalbardAndJanMayen"] = "SJ";
    Country["Swaziland"] = "SZ";
    Country["Sweden"] = "SE";
    Country["Switzerland"] = "CH";
    Country["SyrianArabRepublic"] = "SY";
    Country["Taiwan"] = "TW";
    Country["Tajikistan"] = "TJ";
    Country["Tanzania"] = "TZ";
    Country["Thailand"] = "TH";
    Country["TimorLeste"] = "TL";
    Country["Togo"] = "TG";
    Country["Tokelau"] = "TK";
    Country["Tonga"] = "TO";
    Country["TrinidadAndTobago"] = "TT";
    Country["Tunisia"] = "TN";
    Country["Turkey"] = "TR";
    Country["Turkmenistan"] = "TM";
    Country["TurksAndCaicosIslands"] = "TC";
    Country["Tuvalu"] = "TV";
    Country["Uganda"] = "UG";
    Country["Ukraine"] = "UA";
    Country["UnitedArabEmirates"] = "AE";
    Country["UnitedKingdom"] = "GB";
    Country["UnitedStates"] = "US";
    Country["UnitedStatesOutlyingIslands"] = "UM";
    Country["Uruguay"] = "UY";
    Country["Uzbekistan"] = "UZ";
    Country["Vanuatu"] = "VU";
    Country["Venezuela"] = "VE";
    Country["Vietnam"] = "VN";
    Country["VirginIslandsBritish"] = "VG";
    Country["VirginIslandsUS"] = "VI";
    Country["WallisAndFutuna"] = "WF";
    Country["WesternSahara"] = "EH";
    Country["Yemen"] = "YE";
    Country["Zambia"] = "ZM";
    Country["Zimbabwe"] = "ZW";
})(Country = exports.Country || (exports.Country = {}));
var PhoneType;
(function (PhoneType) {
    PhoneType["Home"] = "1";
    PhoneType["Work"] = "2";
    PhoneType["Mobile"] = "12";
})(PhoneType = exports.PhoneType || (exports.PhoneType = {}));
var AddressTypeCode;
(function (AddressTypeCode) {
    AddressTypeCode["Mailing"] = "Mailing";
    AddressTypeCode["Business"] = "Business";
    AddressTypeCode["Residence"] = "Residence";
    AddressTypeCode["Secondary"] = "Secondary";
})(AddressTypeCode = exports.AddressTypeCode || (exports.AddressTypeCode = {}));
var Gender;
(function (Gender) {
    Gender["F"] = "f";
    Gender["M"] = "m";
    Gender["N"] = "n";
})(Gender = exports.Gender || (exports.Gender = {}));
var Title;
(function (Title) {
    Title["Mr"] = "Mr.";
    Title["Mrs"] = "Mrs.";
    Title["Ms"] = "Ms.";
    Title["Mx"] = "Mx.";
    Title["Hon"] = "Hon.";
    Title["Dr"] = "Dr.";
    Title["Jr"] = "Jr.";
    Title["Sr"] = "Sr.";
    Title["Prof"] = "Prof.";
})(Title = exports.Title || (exports.Title = {}));
var ClaimType;
(function (ClaimType) {
    ClaimType["Death"] = "Death Claim";
    ClaimType["Health"] = "Health Claim";
})(ClaimType = exports.ClaimType || (exports.ClaimType = {}));
var OwnerRole;
(function (OwnerRole) {
    OwnerRole["PrimaryOwner"] = "PrimaryOwner";
    OwnerRole["JointOwner"] = "JointOwner";
})(OwnerRole = exports.OwnerRole || (exports.OwnerRole = {}));
var PolicyKind;
(function (PolicyKind) {
    PolicyKind["LIFE"] = "life";
    PolicyKind["ANNUITY"] = "annuity";
    PolicyKind["DISABILITY"] = "disability";
})(PolicyKind = exports.PolicyKind || (exports.PolicyKind = {}));
var ContOwnerKind;
(function (ContOwnerKind) {
    ContOwnerKind["INSURED"] = "insured";
    ContOwnerKind["OWNERS_ESTATE"] = "owners-estate";
    ContOwnerKind["INDIVIDUAL"] = "indivudual";
    ContOwnerKind["TRUST"] = "trust";
})(ContOwnerKind = exports.ContOwnerKind || (exports.ContOwnerKind = {}));
var GovtIdType;
(function (GovtIdType) {
    GovtIdType["SSN"] = "ssn";
    GovtIdType["EIN"] = "ein";
    GovtIdType["ITIN"] = "itin";
    GovtIdType["Other"] = "Other";
    GovtIdType["DriversLicense"] = "Drivers License";
    GovtIdType["StateID"] = "State ID";
    GovtIdType["Passport"] = "Passport";
    GovtIdType["H1B"] = "H1B";
    GovtIdType["GreenCard"] = "Green Card";
    GovtIdType["NationalIdentityCard"] = "National Identity Card";
})(GovtIdType = exports.GovtIdType || (exports.GovtIdType = {}));
var WorkflowRefType;
(function (WorkflowRefType) {
    WorkflowRefType["PolicyId"] = "PolicyId";
    WorkflowRefType["PolicyNumber"] = "PolicyNumber";
    WorkflowRefType["GroupId"] = "GroupId";
    WorkflowRefType["GroupNumber"] = "GroupNumber";
    WorkflowRefType["RemoveFromGroupBilling"] = "RemoveFromGroupBilling";
    // Batch endpoint reference types
    WorkflowRefType["GetPolicyCostBasis"] = "getPolicyCostBasis";
    WorkflowRefType["GetDeathBenefitValue"] = "getDeathBenefitValue";
    WorkflowRefType["GetChangeFaceAmountInformation"] = "getChangeFaceAmountInformation";
})(WorkflowRefType = exports.WorkflowRefType || (exports.WorkflowRefType = {}));
;
;
var NonForfeitureOptions;
(function (NonForfeitureOptions) {
    NonForfeitureOptions["RPU"] = "RPU";
    NonForfeitureOptions["ETI"] = "ETI";
})(NonForfeitureOptions = exports.NonForfeitureOptions || (exports.NonForfeitureOptions = {}));
var SegmentInfo;
(function (SegmentInfo) {
    SegmentInfo["Tlic"] = "TlicSegment";
    SegmentInfo["Policy"] = "PolicySegment";
    SegmentInfo["FaceIncrease"] = "FaceIncreaseSegment";
    SegmentInfo["ChronicIllnessRider"] = "CIRSegment";
    SegmentInfo["RenewableTermRider"] = "RTRSegment";
    SegmentInfo["GuaranteedInsurabilityRider"] = "GIRSegment";
    SegmentInfo["GuaranteedInsurabilityRiderFaceIncrease"] = "GIRFaceIncreaseSegment";
    SegmentInfo["PUA"] = "PUASegment";
    SegmentInfo["AdditionalLifeInsuranceRider"] = "ALIRSegment";
    SegmentInfo["InitialAdditionalLifeInsuranceRider"] = "ALIRInitialSegment";
    SegmentInfo["DisabilitySegment"] = "DisabilitySegment";
})(SegmentInfo = exports.SegmentInfo || (exports.SegmentInfo = {}));
var RefundBreakdownDescription;
(function (RefundBreakdownDescription) {
    RefundBreakdownDescription["ALIR_GCV"] = "Cash Value of ALIR Paid-Up Adds Purchased By Premiums";
    RefundBreakdownDescription["ALIR_PUA_GCV"] = "Cash Value of ALIR Paid-Up Adds Purchased By Dividends";
    RefundBreakdownDescription["BASE_GCV"] = "Base Guaranteed Cash Value";
    RefundBreakdownDescription["BASE_PUA_GCV"] = "Cash Value of Base Paid Up Additions";
    RefundBreakdownDescription["LOAN_PAYOFF_PRINCIPAL_AMOUNT_GCV"] = "Loan - Principal";
    RefundBreakdownDescription["LOAN_PAYOFF_INTEREST_AMOUNT_GCV"] = "Loan - Interest";
    RefundBreakdownDescription["DIVIDEND_ACCUMULATIONS"] = "Dividend Accumulations";
    RefundBreakdownDescription["DIVIDEND_INTEREST"] = "Accumulated Interest on Dividend";
    RefundBreakdownDescription["DIVIDEND"] = "Dividend";
})(RefundBreakdownDescription = exports.RefundBreakdownDescription || (exports.RefundBreakdownDescription = {}));
var RefundBreakdownPayloadDescription;
(function (RefundBreakdownPayloadDescription) {
    RefundBreakdownPayloadDescription["BASE_GCV"] = "Base Guaranteed Cash Value";
    RefundBreakdownPayloadDescription["DIVIDEND_INTEREST"] = "Accumulated Dividends with Interest";
    RefundBreakdownPayloadDescription["BASE_PUA_GCV"] = "Cash Value of Base PUA";
    RefundBreakdownPayloadDescription["ALIR_PUA_GCV"] = "Cash Value of Base PUA Purchased by Dividends";
    RefundBreakdownPayloadDescription["LOAN_PAYOFF_PRINCIPAL_AMOUNT_GCV"] = "Loan Payoff Principle Amount";
    RefundBreakdownPayloadDescription["LOAN_PAYOFF_INTEREST_AMOUNT_GCV"] = "Loan Payoff Interest Amount";
})(RefundBreakdownPayloadDescription = exports.RefundBreakdownPayloadDescription || (exports.RefundBreakdownPayloadDescription = {}));
var QuotePayloadDescription;
(function (QuotePayloadDescription) {
    QuotePayloadDescription["LOAN_PAYOFF_AMOUNT"] = "Loan Payoff Amount";
    QuotePayloadDescription["LOAN_PAYOFF_PRINCIPLE_AMOUNT"] = "Loan Payoff Principle Amount";
    QuotePayloadDescription["LOAN_PAYOFF_INTEREST_AMOUNT"] = "Loan Payoff Interest Amount";
    QuotePayloadDescription["NET_CASH_SURRENDER_VALUE"] = "Net Cash Surrender Value";
    QuotePayloadDescription["GUARANTEED_CASH_VALUE"] = "Guaranteed Cash Value";
    QuotePayloadDescription["BASE_GUARANTEED_CASH_VALUE"] = "Base Guaranteed Cash Value";
    QuotePayloadDescription["ACCUMULATED_DIVIDENDS_WITH_INTEREST"] = "Accumulated Dividends with Interest";
    QuotePayloadDescription["CASH_VALUE_OF_BASE_PUA"] = "Cash Value of Base PUA";
    QuotePayloadDescription["CASH_VALUE_OF_PUA_PURCHASED_BY_DIVIDENDS"] = "Cash Value of Base PUA Purchased by Dividends";
    QuotePayloadDescription["CASH_VALUE_OF_ALIR_PUA_PURCHASED_BY_DIVIDENDS"] = "Cash Value of ALIR PUA Purchased by Premiums";
    QuotePayloadDescription["FULL_MODAL_PREMIUM"] = "Full Modal Premium";
    QuotePayloadDescription["UNAPPLIED_PREMIUM_REDUCTION_DIVIDENDS"] = "Unapplied Premium Reduction Dividends";
    QuotePayloadDescription["GROSS_CHECK_AMOUNT"] = "Gross Check Amount";
    QuotePayloadDescription["UNEARNED_GROSS_PREMIUM"] = "Unearned Gross Premium";
    QuotePayloadDescription["NET_ANNUAL_PREMIUM"] = "Net Annual Premium";
    QuotePayloadDescription["UNEARNED_RIDER_PREMIUM"] = "Unearned Rider Premium";
})(QuotePayloadDescription = exports.QuotePayloadDescription || (exports.QuotePayloadDescription = {}));
;
;
;
var PUAOptionTypes;
(function (PUAOptionTypes) {
    PUAOptionTypes["MonthlyIncrease"] = "MonthlyIncrease";
    PUAOptionTypes["ExtendedBenefit"] = "ExtendedBenefit";
})(PUAOptionTypes = exports.PUAOptionTypes || (exports.PUAOptionTypes = {}));
var BreakdownType;
(function (BreakdownType) {
    BreakdownType["WaiverBenefit"] = "WaiverBenefit";
    BreakdownType["DeathBenefit"] = "DeathBenefit";
    BreakdownType["GIRBenefit"] = "GIRBenefit";
    BreakdownType["AdbrBenefit"] = "AdbrBenefit";
    BreakdownType["Fee"] = "Fee";
    BreakdownType["LifeFlatExtra"] = "LifeFlatExtra";
    BreakdownType["Rolledup"] = "Rolledup";
    BreakdownType["Refund"] = "Refund";
    BreakdownType["TableRating"] = "TableRating";
    BreakdownType["TlicRefund"] = "TlicRefund";
    BreakdownType["Interest"] = "Interest";
    BreakdownType["AdHoc"] = "AdHoc";
    BreakdownType["Dividend"] = "Dividend";
    BreakdownType["AlirGCVRefund"] = "AlirGCVRefund";
    BreakdownType["LoanPrincipal"] = "LoanPrincipal";
    BreakdownType["LoanInterest"] = "LoanInterest";
    BreakdownType["DividendInterest"] = "DividendInterest";
    BreakdownType["ConversionCredit"] = "ConversionCredit";
    BreakdownType["Discount"] = "Discount";
    BreakdownType["RefundLastPremium"] = "RefundLastPremium";
    BreakdownType["ALIRPUAPartialSurrender"] = "ALIRPUAPartialSurrender";
    BreakdownType["ALIRPartialSurrender"] = "ALIRPartialSurrender";
    BreakdownType["DividendAccumulatePartialSurrender"] = "DividendAccumulatePartialSurrender";
    BreakdownType["PUAPartialSurrender"] = "PUAPartialSurrender";
    BreakdownType["Levy"] = "Levy";
    BreakdownType["OffsetPlan"] = "OffsetPlan";
    BreakdownType["FederalTaxWithholding"] = "FederalTaxWithholding";
    BreakdownType["StateTaxWithholding"] = "StateTaxWithholding";
    BreakdownType["CIRBenefit"] = "CIRBenefit";
    BreakdownType["ALIRCashValueBreakdown"] = "ALIRCashValueBreakdown";
    BreakdownType["ALIRPUACashValueBreakdown"] = "ALIRPUACashValueBreakdown";
    BreakdownType["PUACashValueBreakdown"] = "PUACashValueBreakdown";
})(BreakdownType = exports.BreakdownType || (exports.BreakdownType = {}));
var SegmentKind;
(function (SegmentKind) {
    SegmentKind["TLIC"] = "TlicSegment";
    SegmentKind["ALIR"] = "ALIRSegment";
    SegmentKind["GIR"] = "GIRSegment";
    SegmentKind["RTR"] = "RTRSegment";
    SegmentKind["CIR"] = "CIRSegment";
    SegmentKind["ALIR_INITIAL"] = "ALIRInitialSegment";
    SegmentKind["POLICY"] = "PolicySegment";
    SegmentKind["PUA"] = "PUASegment";
    SegmentKind["DISABILITY"] = "DisabilitySegment";
})(SegmentKind = exports.SegmentKind || (exports.SegmentKind = {}));
;
var BeneficiaryClassification;
(function (BeneficiaryClassification) {
    BeneficiaryClassification["primary"] = "primary";
    BeneficiaryClassification["contingent"] = "contingent";
    BeneficiaryClassification["tertiary"] = "tertiary";
})(BeneficiaryClassification = exports.BeneficiaryClassification || (exports.BeneficiaryClassification = {}));
;
var ContingentOwnerTypes;
(function (ContingentOwnerTypes) {
    ContingentOwnerTypes["insured"] = "insured";
    ContingentOwnerTypes["ownerEstate"] = "ownerEstate";
    ContingentOwnerTypes["contingent"] = "contingent";
})(ContingentOwnerTypes = exports.ContingentOwnerTypes || (exports.ContingentOwnerTypes = {}));
;
var ElasticSearchRequestObjectOwnerClassification;
(function (ElasticSearchRequestObjectOwnerClassification) {
    ElasticSearchRequestObjectOwnerClassification[ElasticSearchRequestObjectOwnerClassification["you"] = 0] = "you";
    ElasticSearchRequestObjectOwnerClassification[ElasticSearchRequestObjectOwnerClassification["joint"] = 1] = "joint";
    ElasticSearchRequestObjectOwnerClassification[ElasticSearchRequestObjectOwnerClassification["trust"] = 2] = "trust";
})(ElasticSearchRequestObjectOwnerClassification = exports.ElasticSearchRequestObjectOwnerClassification || (exports.ElasticSearchRequestObjectOwnerClassification = {}));
;
var ElasticSearchRequestObjectTrustOrEntity;
(function (ElasticSearchRequestObjectTrustOrEntity) {
    ElasticSearchRequestObjectTrustOrEntity[ElasticSearchRequestObjectTrustOrEntity["trust"] = 0] = "trust";
    ElasticSearchRequestObjectTrustOrEntity[ElasticSearchRequestObjectTrustOrEntity["incorporatedEntity"] = 1] = "incorporatedEntity";
    ElasticSearchRequestObjectTrustOrEntity[ElasticSearchRequestObjectTrustOrEntity["nonIncorporatedEntity"] = 2] = "nonIncorporatedEntity";
})(ElasticSearchRequestObjectTrustOrEntity = exports.ElasticSearchRequestObjectTrustOrEntity || (exports.ElasticSearchRequestObjectTrustOrEntity = {}));
;
exports.BeneType = {
    'Spouse or partner/fiancé': '9',
    'Estate: Insured': '2',
    "Trust: Insured's Will": '6',
    'Other Trust': '7',
    'Other Entity': '34',
    'Other Individual': '1',
    'Children born of marriage': '12',
    'Lawful children of insured': '15',
    'Unknown': '0',
    'Complex Beneficiary': '35'
};
var AllowedBeneUpdateType;
(function (AllowedBeneUpdateType) {
    AllowedBeneUpdateType["Spouse"] = "Spouse or partner/fianc\u00E9";
    AllowedBeneUpdateType["InsuredEstate"] = "Estate: Insured";
    AllowedBeneUpdateType["InsuredTrust"] = "Trust: Insured's Will";
    AllowedBeneUpdateType["OtherTrust"] = "Other Trust";
    AllowedBeneUpdateType["Business"] = "Other Entity";
    AllowedBeneUpdateType["OtherIndividual"] = "Other Individual";
    AllowedBeneUpdateType["ChildrenOfMarriage"] = "Children born of marriage";
    AllowedBeneUpdateType["ChildrenOfInsured"] = "Lawful children of insured";
    AllowedBeneUpdateType["ComplexBeneficiary"] = "Complex Beneficiary";
})(AllowedBeneUpdateType = exports.AllowedBeneUpdateType || (exports.AllowedBeneUpdateType = {}));
var WithdrawalPayType;
(function (WithdrawalPayType) {
    WithdrawalPayType["Gross"] = "Gross";
    WithdrawalPayType["Net"] = "Net";
})(WithdrawalPayType = exports.WithdrawalPayType || (exports.WithdrawalPayType = {}));
var WithdrawalType;
(function (WithdrawalType) {
    WithdrawalType["AdHoc"] = "AdHoc";
    WithdrawalType["SWP"] = "SWP";
    WithdrawalType["FullSurrender"] = "FullSurrender";
    WithdrawalType["Disbursement"] = "Disbursement";
})(WithdrawalType = exports.WithdrawalType || (exports.WithdrawalType = {}));
var DisbursementType;
(function (DisbursementType) {
    DisbursementType["_1035Exchange"] = "1035Exchange";
    DisbursementType["ACH"] = "ACH";
    DisbursementType["PayTowardsPremium"] = "PayTowardsPremium";
    DisbursementType["Suspense"] = "Suspense";
})(DisbursementType = exports.DisbursementType || (exports.DisbursementType = {}));
var IssueLoanDisbursementType;
(function (IssueLoanDisbursementType) {
    IssueLoanDisbursementType["Cash"] = "Cash";
    IssueLoanDisbursementType["PayTowardsPremium"] = "PayTowardsPremium";
})(IssueLoanDisbursementType = exports.IssueLoanDisbursementType || (exports.IssueLoanDisbursementType = {}));
var PartialWithdrawalDisbursementType;
(function (PartialWithdrawalDisbursementType) {
    PartialWithdrawalDisbursementType["ACH"] = "ACH";
    PartialWithdrawalDisbursementType["PayTowardsPremium"] = "PayTowardsPremium";
    PartialWithdrawalDisbursementType["Suspense"] = "Suspense";
})(PartialWithdrawalDisbursementType = exports.PartialWithdrawalDisbursementType || (exports.PartialWithdrawalDisbursementType = {}));
var DividendOptionNames;
(function (DividendOptionNames) {
    DividendOptionNames["Accumulate"] = "Dividend Accumulations";
    DividendOptionNames["Cash"] = "Cash";
    DividendOptionNames["PRCash"] = "Premium Reduction then Cash";
    DividendOptionNames["PUA"] = "Paid-Up Additions";
    DividendOptionNames["PRPUA"] = "Premium Reduction then Paid-Up Additions";
})(DividendOptionNames = exports.DividendOptionNames || (exports.DividendOptionNames = {}));
var RefundType;
(function (RefundType) {
    RefundType["UnearnedPremium"] = "UnearnedPremium";
    RefundType["GuaranteedCashValue"] = "GuaranteedCashValue";
    RefundType["TlicRefund"] = "TlicRefund";
})(RefundType = exports.RefundType || (exports.RefundType = {}));
var RefundAction;
(function (RefundAction) {
    RefundAction["Initiate"] = "Initiate";
    RefundAction["Approve"] = "Approve";
    RefundAction["Reject"] = "Reject";
})(RefundAction = exports.RefundAction || (exports.RefundAction = {}));
var CirPoolOption;
(function (CirPoolOption) {
    CirPoolOption["INCREASE"] = "Increase monthly benefit amount";
    CirPoolOption["EXTEND"] = "Extend benefit period";
})(CirPoolOption = exports.CirPoolOption || (exports.CirPoolOption = {}));
var PartyType;
(function (PartyType) {
    PartyType["Individual"] = "Individual";
    PartyType["Organization"] = "Organization";
    PartyType["NonNaturalEntity"] = "NonNaturalEntity";
})(PartyType = exports.PartyType || (exports.PartyType = {}));
var ThirdPartyPaymentStatus;
(function (ThirdPartyPaymentStatus) {
    ThirdPartyPaymentStatus["Success"] = "Success";
    ThirdPartyPaymentStatus["PaymentFailure"] = "PaymentFailure";
})(ThirdPartyPaymentStatus = exports.ThirdPartyPaymentStatus || (exports.ThirdPartyPaymentStatus = {}));
var LifeSegmentType;
(function (LifeSegmentType) {
    LifeSegmentType["TLIC"] = "TlicSegment";
    LifeSegmentType["ALIR"] = "ALIRSegment";
    LifeSegmentType["GIR"] = "GIRSegment";
    LifeSegmentType["RTR"] = "RTRSegment";
    LifeSegmentType["CIR"] = "CIRSegment";
    LifeSegmentType["ALIR_INITIAL"] = "ALIRInitialSegment";
    LifeSegmentType["POLICY"] = "PolicySegment";
    LifeSegmentType["FaceIncreaseSegment"] = "FaceIncreaseSegment";
    LifeSegmentType["PUA"] = "PUASegment";
    LifeSegmentType["ALIRPUA"] = "ALIRPUASegment";
    LifeSegmentType["GIRFaceIncrease"] = "GIRFaceIncreaseSegment";
    LifeSegmentType["Disability"] = "DisabilitySegment";
    LifeSegmentType["DividendAccumulate"] = "DividendAccumulateSegment";
    LifeSegmentType["Dividend"] = "DividendSegment";
})(LifeSegmentType = exports.LifeSegmentType || (exports.LifeSegmentType = {}));
var BenefitTypes;
(function (BenefitTypes) {
    BenefitTypes["Primary"] = "Primary";
    BenefitTypes["Rider"] = "Rider";
    BenefitTypes["Provision"] = "Provision";
})(BenefitTypes = exports.BenefitTypes || (exports.BenefitTypes = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FetchPolicyDetailsFailed"] = "FetchPolicyDetailsFailed";
    ErrorCode["InvalidProductType"] = "InvalidProductType";
    ErrorCode["NoPolicy"] = "NoPolicy";
    ErrorCode["NotApplicableForBusinessReasons"] = "NotApplicableForBusinessReasons";
    ErrorCode["InvalidRequest"] = "InvalidRequest";
    ErrorCode["InternalError"] = "InternalError";
    ErrorCode["SchemaFailure"] = "SchemaFailure";
    ErrorCode["NotFound"] = "NotFound";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var AdjustCoverageActions;
(function (AdjustCoverageActions) {
    AdjustCoverageActions["Add"] = "Add";
    AdjustCoverageActions["Remove"] = "Remove";
})(AdjustCoverageActions = exports.AdjustCoverageActions || (exports.AdjustCoverageActions = {}));
var OffsetPlanType;
(function (OffsetPlanType) {
    OffsetPlanType["FixedAmount"] = "fixedAmount";
    OffsetPlanType["Percentage"] = "percentage";
})(OffsetPlanType = exports.OffsetPlanType || (exports.OffsetPlanType = {}));
;
var OwnerType;
(function (OwnerType) {
    OwnerType["Primary"] = "Primary";
    OwnerType["Contingent"] = "Contingent";
})(OwnerType = exports.OwnerType || (exports.OwnerType = {}));
var PhoneTypeDescription;
(function (PhoneTypeDescription) {
    PhoneTypeDescription["Mobile"] = "Mobile";
    PhoneTypeDescription["Home"] = "Home";
    PhoneTypeDescription["Work"] = "Work";
})(PhoneTypeDescription = exports.PhoneTypeDescription || (exports.PhoneTypeDescription = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["Entity"] = "Entity";
    TrusteeType["Person"] = "Person";
})(TrusteeType = exports.TrusteeType || (exports.TrusteeType = {}));
var EntityType;
(function (EntityType) {
    EntityType["Estate"] = "Estate";
    EntityType["Trust"] = "Trust";
    EntityType["Business"] = "Business";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var UpdateBeneAction;
(function (UpdateBeneAction) {
    UpdateBeneAction["DELETE"] = "delete";
    UpdateBeneAction["CREATE"] = "create";
    UpdateBeneAction["MODIFY"] = "modify";
})(UpdateBeneAction = exports.UpdateBeneAction || (exports.UpdateBeneAction = {}));
var TrustType;
(function (TrustType) {
    TrustType["revocable"] = "revocable";
    TrustType["irrevocable"] = "irrevocable";
})(TrustType = exports.TrustType || (exports.TrustType = {}));
var beneficiaryPerStirpes;
(function (beneficiaryPerStirpes) {
    beneficiaryPerStirpes["Yes"] = "Yes";
    beneficiaryPerStirpes["No"] = "No";
})(beneficiaryPerStirpes = exports.beneficiaryPerStirpes || (exports.beneficiaryPerStirpes = {}));
var PolicyDocTypeEnum;
(function (PolicyDocTypeEnum) {
    PolicyDocTypeEnum["Address_Change_Form"] = "Address Change Form";
    PolicyDocTypeEnum["Annual_Statement"] = "AnnualStatement";
    PolicyDocTypeEnum["Annual_Statement_1"] = "Annual Statement";
    PolicyDocTypeEnum["Annuity_Application"] = "AnnuityApplication";
    PolicyDocTypeEnum["Annuity_Packet"] = "AnnuityPacket";
    PolicyDocTypeEnum["Bank_Change_Form"] = "Bank Change Form";
    PolicyDocTypeEnum["Beneficiary_Change_Form"] = "Beneficiary Change Form";
    PolicyDocTypeEnum["Cancel_Policy_Form"] = "Cancel Policy Form";
    PolicyDocTypeEnum["Change_Payment_Date_Form"] = "Change Payment Date Form";
    PolicyDocTypeEnum["Claims_Packet"] = "Claims Packet";
    PolicyDocTypeEnum["Collateral_Assignment"] = "Collateral Assignment";
    PolicyDocTypeEnum["Conversion_Form"] = "Conversion Form";
    PolicyDocTypeEnum["Disability_Application"] = "DisabilityApplication";
    PolicyDocTypeEnum["Disability_Policy_Packet"] = "DisabilityPolicyPacket";
    PolicyDocTypeEnum["Divorce_Settlement"] = "Divorce Settlement";
    PolicyDocTypeEnum["Face_Decrease_Form"] = "Face Decrease Form";
    PolicyDocTypeEnum["Name_Change_Form"] = "Name Change Form";
    PolicyDocTypeEnum["Old_Policy_Packet"] = "OldPolicyPacket";
    PolicyDocTypeEnum["Other"] = "Other";
    PolicyDocTypeEnum["Owner_Change_Form"] = "Owner Change Form";
    PolicyDocTypeEnum["Payment_Change_Confirmation"] = "PaymentChangeConfirmation";
    PolicyDocTypeEnum["Policy_Packet"] = "PolicyPacket";
    PolicyDocTypeEnum["Post_Issue_Docs"] = "PostIssueDocs";
    PolicyDocTypeEnum["Re_Instatement_Form"] = "Re-instatement Form";
    PolicyDocTypeEnum["Re_Issuance_Form"] = "Re-issuance Form";
    PolicyDocTypeEnum["Re_Underwriting_Form"] = "Re-underwriting Form";
    PolicyDocTypeEnum["Rider_Removal_Form"] = "Rider Removal Form";
    PolicyDocTypeEnum["Secondary_Addressee"] = "Secondary Addressee";
    PolicyDocTypeEnum["Third_Party_Authorization"] = "Third party authorization";
    PolicyDocTypeEnum["Tranche_Purchase_Statement"] = "TranchePurchaseStatement";
    PolicyDocTypeEnum["Active_Cancellation_Notice"] = "ActiveCancellationNotice";
    PolicyDocTypeEnum["Address_Update"] = "Address Update";
    PolicyDocTypeEnum["Annual_Statement_Owner_1"] = "Annual Statement_owner_1";
    PolicyDocTypeEnum["Annual_Variable_Loan_Interest_Rate"] = "Annual Variable Loan Interest Rate";
    PolicyDocTypeEnum["Beneficiary_Confirmation"] = "Beneficiary Confirmation";
    PolicyDocTypeEnum["Cash_Loan_Confirmation"] = "Cash Loan Confirmation";
    PolicyDocTypeEnum["Conversion_Confirmation"] = "Conversion Confirmation";
    PolicyDocTypeEnum["Direct_Bill_Notice_Of_Payment_Due"] = "Direct Bill Notice of Payment Due";
    PolicyDocTypeEnum["Draft_Change_Notification"] = "Draft Change Notification";
    PolicyDocTypeEnum["Draft_Day_Change"] = "Draft Day Change";
    PolicyDocTypeEnum["Grace_Notice"] = "GraceNotice";
    PolicyDocTypeEnum["Grace_Notice_1"] = "Grace Notice";
    PolicyDocTypeEnum["Guaranteed_Insurability_Rider_Option_Notification"] = "Guaranteed Insurability Rider Option Notification";
    PolicyDocTypeEnum["Lapsed_Notification"] = "Lapsed Notification";
    PolicyDocTypeEnum["Lapse_Notice"] = "LapseNotice";
    PolicyDocTypeEnum["Lapse_Notice_1"] = "Lapse Notice";
    PolicyDocTypeEnum["Lapse_Notice_Owner_1"] = "Lapse Notice_owner_1";
    PolicyDocTypeEnum["Level_Premium_Change"] = "Level Premium Change";
    PolicyDocTypeEnum["Life_Settlement_Notification"] = "Life Settlement Notification";
    PolicyDocTypeEnum["Loan_And_Loan_Interest_Payment_Confirmation"] = "Loan and Loan Interest Payment Confirmation";
    PolicyDocTypeEnum["Loan_For_Interest_Confirmation"] = "Loan for Interest Confirmation";
    PolicyDocTypeEnum["Loan_Interest_Payment"] = "Loan Interest Payment";
    PolicyDocTypeEnum["Loan_Payment_Confirmation"] = "Loan Payment Confirmation";
    PolicyDocTypeEnum["Loan_Proceeds"] = "Loan Proceeds";
    PolicyDocTypeEnum["Name_Change_Confirmation"] = "Name Change Confirmation";
    PolicyDocTypeEnum["New_Address_Change_Notice"] = "NewAddressChangeNotice";
    PolicyDocTypeEnum["Old_Address_Change_Notice"] = "OldAddressChangeNotice";
    PolicyDocTypeEnum["Option_To_Convert"] = "Option to Convert";
    PolicyDocTypeEnum["Owner_Change_Confirmation"] = "Owner Change Confirmation";
    PolicyDocTypeEnum["Payment_Failure_Notification"] = "Payment Failure Notification";
    PolicyDocTypeEnum["Payment_Frequency_Change"] = "Payment Frequency Change";
    PolicyDocTypeEnum["Payment_Update"] = "Payment Update";
    PolicyDocTypeEnum["Policy_Cancel_Confirmation"] = "Policy Cancel Confirmation";
    PolicyDocTypeEnum["Policy_Change_Confirmation"] = "Policy Change Confirmation";
    PolicyDocTypeEnum["Policy_Disbursement"] = "Policy Disbursement";
    PolicyDocTypeEnum["Premium_Loan_Confirmation"] = "Premium Loan Confirmation";
    PolicyDocTypeEnum["Refund_Failure_Notification"] = "Refund Failure Notification";
    PolicyDocTypeEnum["Rider_Expiration_Notice"] = "Rider Expiration Notice";
    PolicyDocTypeEnum["Rpunotice"] = "RPUNotice";
    PolicyDocTypeEnum["Trustee_Change"] = "Trustee Change";
    PolicyDocTypeEnum["Withdrawal_Request"] = "Withdrawal Request";
})(PolicyDocTypeEnum = exports.PolicyDocTypeEnum || (exports.PolicyDocTypeEnum = {}));
